/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { css } from '@emotion/react'

export const staticMap = css`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;

  overflow: hidden;

  line-height: 0;

  border-radius: 5px;
`

export const image = css`
  flex-grow: 0;
  flex-shrink: 0;

  opacity: 0;

  transition: opacity 300ms ease-in-out;
`

export const imageLoaded = css`
  opacity: 1;
`

export const children = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 50%;
  left: 0;

  display: flex;
  align-items: flex-end;
  justify-content: center;
`

export const loading = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  opacity: 1;
  filter: blur(6px);

  transition: opacity 300ms ease-in-out;
`

export const loadingDone = css`
  opacity: 0;
`
